<template>
  <div :class="nameclass || 'DateDefaultClass'">
    <label for="date-input" v-if="label != '_'">{{ label || "Select Date" }}</label>
    <b-input-group>
      <b-form-input
        v-model="values"
        type="text"
        placeholder="YYYY-MM-DD"
        autocomplete="off"
        @input="(event) => {
          $emit('update', event);}"
        size="lg"
        :style="{backgroundColor:value ? 'rgba(79, 208, 110,0.2)':'aliceblue'}"
      ></b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          button-variant="primary"
          v-model="values"
          button-only
          right
          locale="en-US"
          aria-controls="date-input"
          @input="(event) => {
          $emit('update', event);}"
          size="lg"
          :style="{backgroundColor:value ? 'rgba(79, 208, 110,0.2)':'aliceblue'}"
        ></b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: ["value", "nameclass", "label"],
  model: {
    prop: "value",
    event: "update"
  },
  data() {
    return {
      values: this.value
    };
  },
  watch: {
    value: function(updated, old) {
      if (updated) {
        this.values = updated;
      }
    }
  }
};
</script>